import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
(function injectPerfHints() {
  if (typeof document === 'undefined') return;
  const head = document.head;
  const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/dpFyDM2gcDHWgCcZXkixzj/Imagen_Producto.webp';
  const hints: Array<{
    rel: string;
    href: string;
    as?: string;
    crossorigin?: boolean;
    fetchpriority?: string;
  }> = [{
    rel: 'preconnect',
    href: 'https://fonts.googleapis.com'
  }, {
    rel: 'preconnect',
    href: 'https://fonts.gstatic.com',
    crossorigin: true
  }, {
    rel: 'preconnect',
    href: 'https://cdn.magicpatterns.com'
  }, {
    rel: 'preload',
    href: HERO_IMAGE,
    as: 'image',
    fetchpriority: 'high'
  }];
  hints.forEach(h => {
    // Avoid duplicates on hot reload
    const selector = `link[rel="${h.rel}"][href="${h.href}"]`;
    if (head.querySelector(selector)) return;
    const link = document.createElement('link');
    link.rel = h.rel;
    link.href = h.href;
    if (h.as) link.setAttribute('as', h.as);
    if (h.crossorigin) link.setAttribute('crossorigin', '');
    if (h.fetchpriority) link.setAttribute('fetchpriority', h.fetchpriority);
    head.appendChild(link);
  });
})();
render(<App data-id="element-263" />, document.getElementById('root'));